import React, { useCallback } from 'react'
import Sheet from 'components/utils/Sheet'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import TextButton from 'LuxKit/Button/TextButton'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { hasSelectedRooms } from 'lib/offer/offerPageUtil'

interface Props {
  selectedRooms: boolean,
}

function BedbankMultiRoomNoDatesCTA({ selectedRooms }: Props) {
  const offerPageDispatch = useOfferPageDispatch()

  const handleCheckAvailabilityClick = useCallback(() => {
    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: selectedRooms ? 'checkin' : 'capacity' })
  }, [offerPageDispatch, selectedRooms])

  return <Sheet padding={20} background="neutral-eight">
    <TextButton kind="primary" onClick={handleCheckAvailabilityClick} size="large" fit="full-width">
      Check availability
    </TextButton>
  </Sheet>
}

export default withOfferPageState(state => ({
  selectedRooms: hasSelectedRooms(state.rooms),
}), BedbankMultiRoomNoDatesCTA)
